import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=36c19b8a"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c19b8a')) {
      api.createRecord('36c19b8a', component.options)
    } else {
      api.reload('36c19b8a', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=36c19b8a", function () {
      api.rerender('36c19b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/Page.vue"
export default component.exports